// this file is also used by gatsby-node.js which has not supportted ES Modules
module.exports.APP_LAYOUT_TYPES = {
  LOGIN_LAYOUT: "login-layout",
  ERROR_LAYOUT: "error-layout",
  SHARING_LAYOUT: "sharing-layout",
  DASHBOARD_LAYOUT: "dashboard-layout",
  LOAN_APPLICATION_LAYOUT: "loan-application-layout",
};
